// removed by extract-text-webpack-plugin
module.exports = {"CollectionsFooterWrap":"styles__CollectionsFooterWrap___cM-9x","CollectionsFooter":"styles__CollectionsFooter___1r_FC","CollectionsFooterLogo":"styles__CollectionsFooterLogo___1GNfm","CollectionsFooterTitle":"styles__CollectionsFooterTitle___1YNYA","CollectionsFooterText":"styles__CollectionsFooterText___2wapn","CollectionsFooterAgencyName":"styles__CollectionsFooterAgencyName___O7UIO","CollectionsFooterNote":"styles__CollectionsFooterNote___CWLHh","CollectionsFooterItems":"styles__CollectionsFooterItems___2hm_m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/ClientHeader/Footer/styles.scss
// module id = 1401
// module chunks = 0